import React from 'react'
// import "./bootstrap.min.css"

export default function HomeContent() {
  return (

    <>
      <style>{`
.image-holder img{
    max-width: 300px;
   
  }
  .step img{
    max-width: 200px;
    border-radius: 20px;
   
  }
  .image-holder {
    position: relative;
  }
  .image-holder::after{
    content: "";
    width: 100px;
    height: 100px;
    position: absolute;
    right: 32px;
    top: -37px;
    background: #FFBE10;
    border-radius: 100px;
    z-index: -1;
  }
  
  .app-logo img{
    max-width: 200px;
  }
  .google-play{
    background:#371400;
    padding: 10px;
    text-align: center;
    color: #fff;
    font-size: 30px;
  }
  p{
    color: #000;
  }
  ul{
    padding-left: 10px;
  }
  ul li{
    line-height: 25px;
    padding-left: 0px;
    padding-top: 10px;
}
h3,h1{
    color: #371300;
}
.content {
    background:#371400;
    text-align: center;
    padding: 0 20px 30px;
    margin-top: 30px;
   
}
.content p{
    color: #fff;
    font-size: 12px; 
    padding-top: 30px;
    line-height: 19px;
    max-width: 700px;
    margin: 0 auto;
}
@media only screen and (max-width: 768px) {
.revers-col{
    flex-direction: column-reverse;
}
.pad-off{
    padding: 0 !important;
}
}
`}</style>



      <div className="" style={{ backgroundColor: "#F5F0F0" }}>
        <div className="container pb-5 w-full mx-auto" style={{ backgroundColor: "#F5F0F0" }}>
          <header className="post-article-header d-flex pt-5 align-items-center justify-content-center">
            <div className="text-holder text-center">
              <img src="./assets/logo.png" className=" mx-auto" />
              <h1 className='mb-2'>Download Our App Today</h1>
              <div className="col-md-12" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', gap: '24px', marginTop: '16px', flexWrap: 'wrap' }}>
                <a href="https://apps.apple.com/in/app/tsofie/id6475926878" target="_blank" rel="noopener noreferrer" className="hover:scale-105 transition-transform duration-200" style={{ display: 'inline-block' }}>
                  <img src="./assets/apple-store-icon.png" alt="App Store" style={{ height: '48px', width: 'auto' }}/></a> 
                <a href="https://tsofie.com/app.apk" download className="hover:scale-105 transition-transform duration-200" style={{ display: 'inline-block' }}>
                  <img src="./assets/playstore-icon.png" alt="Google Play" style={{ height: '48px', width: 'auto' }}/></a> 
              </div>
            </div>

          </header>
        </div>
      </div>
      <div className="content-section hero-section bg-primary bg-decor" style={{ backgroundColor: "#fff" }}></div>
      <div className="google-play ">
        <div className=" flex-wrap col-md-6 m-auto align-items-center justify-content-center">
          <div className="col-md-9 col-sm-12"> Let's Install with Google plays</div>
          <div className="col-md-3 col-sm-12"> <a title='Tsofie_V1_1.apk' id="downloadAppButton" href="https://tsofie.com/app.apk" download className="app-logo">
            <img src="./assets/playstore-icon-white-removebg-preview.png" className="w-100 mx-auto" /></a></div>
        </div>
      </div>
      <div className="w-full px-4 mx-auto">
        {/* Step 1 */}
        <div className="flex flex-wrap items-center justify-center pt-5">
          <div className="w-full md:w-3/4 lg:w-3/4 mb-5 pr-5">
            <h3 className="text-xl font-semibold mb-4">Step 1: Download the App</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Visit the Website: Go to the Tsofie website.</li>
              <li>Locate the Android App Button: Find the button or link labeled "Download Android App."</li>
              <li>
                Start Download: Click on the button to initiate the download process. The app will be downloaded as a .apk file and saved to your device's Downloads folder.
              </li>
            </ul>
          </div>
          <div className="image-holder mt-10 w-full md:w-1/4">
            <img src="./assets/111.jpeg" className="w-[50%] ms-20 rounded-lg shadow" alt="Step 1" />
          </div>
        </div>

        {/* Step 2 */}
        <div className="flex flex-wrap items-center justify-center pt-5 flex-col-reverse md:flex-row">
          <div className="w-full md:w-1/4 image-holder ">
            <img src="./assets/222.jpeg" className="w-[50%] ms-20 h-auto rounded-lg shadow" alt="Step 2" />
          </div>
          <div className="w-full md:w-3/4 pl-5">
            <h3 className="text-xl font-semibold mb-4">Step 2: Install the App</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-700">
              <li>Access Downloads: Open your device's file manager and navigate to the Downloads folder.</li>
              <li>Locate the APK: Find the "TsofieApp.apk" file.</li>
              <li>Tap to Install: Tap on the APK file to start the installation process.</li>
              <li>Security Prompt: You may see a prompt asking if you want to allow installations from unknown sources. If prompted, enable this setting (usually found in Settings &gt; Security or Privacy).</li>
              <li>Installation Progress: The app will begin installing. This may take a few minutes.</li>
              <li>Scan App (Optional): If a "Scan app" prompt appears, click on it to allow the device to scan the app for any potential security issues. This is a recommended step for your safety.</li>
              <li>Complete Installation: Once the scan is complete or if no scan is required, click on "Install" again to finish the installation process.</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="content  text-center">
        <p> After Installation:
          * The Tsofie app will be installed on your device.
          * You can now open the app from your device's app drawer.
          By following these steps, you should be able to successfully download and install the Tsofie Android app on your device.</p>
      </div>

    </>
  )
}
